import { OrganizationDB } from "./types";

export const MOCKED_ORGANIZATION_DEFAULTS: OrganizationDB = {
    id: 'DEFAULT',
    organization_guid: '',
    display_name: '',
    machine_name: '',
    okta_group_id: '',
    metadata_schema_type: "",
    okta_application_id: '',
    is_active: true,
    client_id: "test",
    client_secret: "test123"
};
